import { observer } from "mobx-react-lite"
import SingleTHeader from "./SingleTHeader";
import useContextMenu from "../../hooks/useContextMenu";
import MenuContext from "../ui/MenuContext";
import SingleRow from "./SingleRow";
import { useEffect, useState } from "react";
import ExpensesAPI from "../../API/ExpensesAPI";

const SingleTable = ({ header, topHeader, children }) => {
    // header = { 
    //      title: "Кол-во номенклатуры", 
    //      list: [
    //          { "name": "0-5", "value": 5 },
    //          { "name": "5-15", "value": 15 },
    //      ] 
    // }

    return (
        <div className="single_TABLE">
            { topHeader && <div style={{
                boxSizing: "border-box",
                paddingLeft: "180px",
                marginBottom: "20px",
                width: "100%",
                textAlign: "center",
            }}>{topHeader}</div>}
            <table>
                <thead>
                    <tr>
                        { header && <SingleTHeader value={header.title}/> }
                        { header && header.list.length > 0 && header.list.map((col, index) => 
                            <SingleTHeader value={col.name} key={col+index}/>
                        ) }
                    </tr>
                </thead>
                <tbody>
                    { children }
                </tbody>
            </table>
        </div>
    );
}

export default observer(SingleTable);
